module.exports = __webpack_public_path__ + "static/media/blackwater-featured.b664df60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/featured-imgs/blackwater-featured.jpg
// module id = 472
// module chunks = 0